export var DEFAULT_COLOR = '#4fa94d';
export var DEFAULT_WAI_ARIA_ATTRIBUTE = {
    'aria-busy': true,
    role: 'status',
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-loader-spinner/dist/esm/type.js
// module id = 51
// module chunks = 0